// function tree helpers
// not in common helpers.js as they're very specific to function and grade and not generic

export const findObject = (arr, id, key = 'function', childrenKey = 'childFunctions') => {
  // https://stackoverflow.com/a/52205522/8487836
  let result;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key].uuid === id) {
      result = arr[i].function;
      break;
    }
    if (arr[i][childrenKey]) {
      result = findObject(arr[i][childrenKey], id);
      if (result) break;
    }
  }
  return result;
};

export const findGradesAndRolesOfFunction = (arr, id, key = 'function', childrenKey = 'childFunctions') => {
  // https://stackoverflow.com/a/52205522/8487836
  let result;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key].uuid === String(id)) {
      result = arr[i];
      break;
    }
    if (arr[i][childrenKey]) {
      result = findGradesAndRolesOfFunction(arr[i][childrenKey], id);
      if (result) break;
    }
  }
  return result;
};

export const getArrayOfIdsOfParentFunctions = (arr, child, prev = []) => {
  // this will return array of parent ids
  // it's needed to open the tree to
  const array = [...prev];
  if (child && !child.parentId) {
    return array;
  }
  if (!child) {
    return array;
  }
  const result = findObject(arr, String(child.parentId));
  if (result) {
    array.push(result);
  }
  const arra = getArrayOfIdsOfParentFunctions(arr, result, array);
  return arra;
};

export const findParent = (arr, id, key = 'function', childrenKey = 'childFunctions') => {
  let result;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key].uuid === id) {
      result = arr[i];
      break;
    }
    if (arr[i][childrenKey]) {
      result = findParent(arr[i][childrenKey], id);
      if (result) break;
    }
  }
  return result;
};
